var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "facebook_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.446a10.136 10.136 0 0 1-2 0v-7.95h-1a1 1 0 1 1 0-2h1v-2a3 3 0 0 1 3-3h1a1 1 0 1 1 0 2h-1a1 1 0 0 0-1 1v2h2a1 1 0 1 1 0 2h-2v7.95z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.496a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0 2c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z",
    fill: "currentColor"
  })));
};

export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTMgMjIuNDQ2YTEwLjEzNiAxMC4xMzYgMCAwMS0yIDB2LTcuOTVoLTFhMSAxIDAgMTEwLTJoMXYtMmEzIDMgMCAwMTMtM2gxYTEgMSAwIDExMCAyaC0xYTEgMSAwIDAwLTEgMXYyaDJhMSAxIDAgMTEwIDJoLTJ2Ny45NXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMjAuNDk2YTggOCAwIDEwMC0xNiA4IDggMCAwMDAgMTZ6bTAgMmM1LjUyMyAwIDEwLTQuNDc3IDEwLTEwcy00LjQ3Ny0xMC0xMC0xMC0xMCA0LjQ3Ny0xMCAxMCA0LjQ3NyAxMCAxMCAxMHoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";